var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { faIcons } from './faIcons';
import { indicons } from './indicons';
import { partnerIcons } from './partnerIcons';
const allIcons = Object.assign(Object.assign(Object.assign({}, faIcons), indicons), partnerIcons);
/**
 * Generic icon component, hidden from Assistive Technology by default.
 * If icon should be available to AT, pass the desired name into the `ariaLabel` prop.
 */
export function Icon(_a) {
    var _b;
    var { style = {} } = _a, props = __rest(_a, ["style"]);
    const ariaLabel = props.ariaLabel
        ? { 'aria-label': props.ariaLabel }
        : { 'aria-hidden': true, focusable: false };
    const iconComponentProps = ((_b = allIcons[props.name]) === null || _b === void 0 ? void 0 : _b.props) || null;
    const dimensions = props.size && props.size.length > 0
        ? returnDimensions(props.size)
        : { width: '1em', height: '1em' };
    if (!iconComponentProps) {
        console.error(`${props.name} is not a valid icon name.`);
        return null;
    }
    return (React.createElement("svg", Object.assign({}, iconComponentProps, ariaLabel, dimensions, { role: "img", className: props.className, "data-cy": props['data-cy'], "data-testid": props['data-testid'], fill: props.fill || 'currentColor', id: props.id, style: style, onClick: props.onClick })));
}
function returnDimensions(sizeProp) {
    if (sizeProp.length > 1) {
        return { width: sizeProp[0], height: sizeProp[1] };
    }
    return { width: sizeProp[0], height: sizeProp[0] };
}
//# sourceMappingURL=Icon.js.map